import { Timeout } from '../common/const';

export const initLazyload = () => {
    let lazyImages = [].slice.call(document.querySelectorAll(`img.lazy`));
    if (!lazyImages.length) return;

    if (`IntersectionObserver` in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.srcset = lazyImage.dataset.srcset;

                    lazyImageObserver.unobserve(lazyImage);

                    setTimeout(() => {
                        lazyImage.classList.remove(`lazy`);
                    }, Timeout.ANIMATION_TIMEOUT);
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }
}


